var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLegalDrama = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Legal-Hammer--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Legal Hammer Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3 21h8a1 1 0 0 0 1 -1v-1.5a1.5 1.5 0 0 0 -1.5 -1.5h-7A1.5 1.5 0 0 0 2 18.5V20a1 1 0 0 0 1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 18a1.61 1.61 0 0 0 0 -2.33l-6.81 -6.14a0.28 0.28 0 0 1 -0.09 -0.18 0.25 0.25 0 0 1 0.08 -0.18l1.76 -1.76a0.26 0.26 0 0 1 0.33 0 1.48 1.48 0 0 0 0.9 0.3 1.53 1.53 0 0 0 1.06 -0.44 1.51 1.51 0 0 0 0 -2.12L15.54 0.44a1.49 1.49 0 0 0 -2.12 0 1.51 1.51 0 0 0 -0.14 2 0.23 0.23 0 0 1 0 0.32l-5.56 5.5a0.23 0.23 0 0 1 -0.32 0 1.51 1.51 0 0 0 -2 0.14 1.49 1.49 0 0 0 0 2.12l4.68 4.69a1.5 1.5 0 0 0 2.26 -2 0.26 0.26 0 0 1 0 -0.33l1.76 -1.76a0.25 0.25 0 0 1 0.18 -0.08 0.21 0.21 0 0 1 0.18 0.09L20.67 18A1.61 1.61 0 0 0 23 18Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22h-11a1 1 0 0 0 0 2h11a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLegalDrama);
export default ForwardRef;